






































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Button from '@/components/Controls/Button/Button.vue';
import Chart from '@/components/Chart/Chart.vue';
import { Actions, Settings } from './types';
import {http} from "@/http";
import Spinner from "@/components/Spinner";
import Select from "@/components/Controls/Select";

@Component({
    components: {
        Select,
        Spinner,
        Button,
        Chart
    },
})
export default class Action extends Vue {

    public actions: Actions = {};
    public articles: Array<any> = [];

    @Prop()
    public readonly settings!: any;

    public themeOptions: any = [];
    public theme: any = "-1";
    public tags: any = "";

    public async fetchContent(pagination, update){
        if( this.settings.actionList ) {

          let resUrl = this.settings.actionList + location.search;
          if(update) {
            const param = new URLSearchParams({});

            if (this.theme != "" && this.theme != "-1") {
              param.append('ti', this.theme);
            } else if (this.tags != "") {
              param.append('tag', this.tags);
            }
            if (pagination && this.actions.paginator) {
              param.append('page', this.actions.paginator.nextPageNumber);
            }

            resUrl = this.settings.actionList;

            if (param.toString() === "") {
              history.replaceState(null, '', location.origin+location.pathname);
            } else {
              resUrl = this.settings.actionList + "?" + param;
              history.replaceState(null, '', '?' + param);
            }
          }

          try {
            const {data} = await http.get<Actions>(resUrl);
            this.actions =  data;
            if(pagination) {
                 this.articles = this.articles.concat(data.actions);
            }else{
                this.articles = data.actions;
            }
          } catch (error) {
              this.$errorLog(error);
          }
        }
    }

    public async onPaginator(){
      this.$wait.start('fetchContentAction');
        await this.fetchContent(true, true);
      this.$wait.end('fetchContentAction');
    }
    public async fetchThemeOptions(){
        try {
            const { data } = await http.get(this.settings.themeList);
            const urlOrigin = new URL(location.href);
            const ti = urlOrigin.searchParams.get('ti');
            let themeTemp = [{
                label: "Все",
                value: '-1',
            }];
            data.forEach( item => {
                if(item.index == ti){
                    this.theme = item.index.toString();
                }
                let t = {label: item.theme,value: item.index.toString()};
                themeTemp.push(t);
            });
            this.themeOptions = themeTemp;
        } catch (error) {
            this.$errorLog(error);
        }
    }
    public async onThemeChange(){
      this.tags = "";
      this.$wait.start('fetchContentAction');
        await this.fetchContent(false, true);
      this.$wait.end('fetchContentAction');
    }
    public async onTagsChange(tag){
      this.theme = "-1";
      this.tags = tag;

      this.$wait.start('fetchContentAction');
        await this.fetchContent(false, true);
      this.$wait.end('fetchContentAction');
    }
  public async onAll(){
    this.theme = "-1";
    this.tags = "";

    this.$wait.start('fetchContentAction');
    await this.fetchContent(false, true);
    this.$wait.end('fetchContentAction');
  }
    async created() {
        await this.fetchThemeOptions();

        this.$wait.start('fetchContentAction');
            await this.fetchContent(false, false);
        this.$wait.end('fetchContentAction');
    }
}
